const addFolderPanelActionsTypes = {
    SHOW_ADD_FOLDER_PANEL: "SHOW_ADD_FOLDER_PANEL",
    HIDE_ADD_FOLDER_PANEL: "HIDE_ADD_FOLDER_PANEL",
    FOLDER_MAPPINGS_LOADED: "FOLDER_MAPPINGS_LOADED",
    LOAD_FOLDER_MAPPINGS_ERROR: "LOAD_FOLDER_MAPPINGS_ERROR",
    CHANGE_NAME: "CHANGE_NAME",
    CHANGE_FOLDER_TYPE: "CHANGE_FOLDER_TYPE",
    FOLDER_CREATED: "FOLDER_CREATED",
    ADD_FOLDER_ERROR: "ADD_FOLDER_ERROR",
    SET_VALIDATION_ERRORS: "SET_VALIDATION_ERRORS"
};

export default addFolderPanelActionsTypes;